import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from 'Root/App/Button'

interface Props {
  onRemoveCallback: Function
}

const RemoveButton = ({ onRemoveCallback }: Props) => {
  return (
    <Button
      className="text-white bg-red-400"
      size="S"
      type="button"
      onClick={onRemoveCallback}
    >
      <FontAwesomeIcon icon={faTrashAlt} />
    </Button>
  )
}

export default RemoveButton
